import React from 'react';

//	L O C A L E

import { locale___ComOverlayComponent } from './com-overlay.locale';

//	S T Y L E

import './com-overlay.scss';

//	P R O P S

import { props___ComOverlayComponent, state___ComOverlayComponent, state___ComOverlayComponent___default } from './com-overlay.state';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';


//	E X P O R T

export default class ComOverlayComponent extends React.Component<props___ComOverlayComponent, state___ComOverlayComponent> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComOverlayComponent,
	) {
		super(props);
		this.state = state___ComOverlayComponent___default;
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			{(this.state.overlay___isActive === true) ? <>
				<div className="com-overlay---container" onClick={() => { this.setState({ overlay___isActive: false }); }}>
					<div className="com-overlay---icon">
						<img src="./assets/ui/gestures/tap.png" />
						<img src="./assets/ui/gestures/swipe.png" />
						<img src="./assets/ui/gestures/zoom.png" />
					</div>
					<h3 className="com-overlay---text">
						{ this._LOCALE.translate(locale___ComOverlayComponent.click_to_enable_controls) }
					</h3>
				</div>
			</> : <>
				<div className="com-overlay---button" onClick={() => { this.setState({ overlay___isActive: true }); }}>
					<i className="fas fa-window-restore"></i>
				</div>
			</>}
		</>;
	}

//#endregion

}